import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULTS = {
  name: '梅谷彩雲',
  nameKana: 'うめたに さいうん',
  bio: '16歳で出家得度し仏門に入門。大学時代には浜松市芸術祭で大賞を受賞し、その後16年間にわたり公立高校の国語科教諭・書道部顧問を務める。令和2年、長年の経験と修練を経て「虹嶺庵」を開業し、伝統書道を現代に発信し続けている。',
  timeline: [
    { year: '16歳', text: '出家得度し仏門に入門' },
    { year: '大学時代', text: '浜松市芸術祭にて大賞受賞' },
    { year: '16年間', text: '公立高校 国語科教諭・書道部顧問を務める' },
    { year: '令和2年', text: '「虹嶺庵」を開業' },
  ],
  credentials: [
    '虹嶺書法會・彩雲書道教室 主宰',
    '日蓮宗 教師',
    '毛筆・硬筆書写検定1級（文部科学省認定）',
    '各種展覧会 入賞・入選 多数',
  ],
};

function timelineToText(timeline) {
  return timeline.map((t) => `${t.year}|${t.text}`).join('\n');
}

function textToTimeline(text) {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [year, ...rest] = line.split('|');
      return { year: (year || '').trim(), text: rest.join('|').trim() };
    });
}

export default function AdminProfile() {
  const [name, setName] = useState(DEFAULTS.name);
  const [nameKana, setNameKana] = useState(DEFAULTS.nameKana);
  const [bio, setBio] = useState(DEFAULTS.bio);
  const [timelineText, setTimelineText] = useState(timelineToText(DEFAULTS.timeline));
  const [credentialsText, setCredentialsText] = useState(DEFAULTS.credentials.join('\n'));
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');

  useEffect(() => {
    getDoc(doc(db, 'siteContent', 'profile')).then((snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setName(data.name ?? DEFAULTS.name);
        setNameKana(data.nameKana ?? DEFAULTS.nameKana);
        setBio(data.bio ?? DEFAULTS.bio);
        setTimelineText(timelineToText(data.timeline ?? DEFAULTS.timeline));
        setCredentialsText((data.credentials ?? DEFAULTS.credentials).join('\n'));
      }
    });
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus('');
    try {
      await setDoc(doc(db, 'siteContent', 'profile'), {
        name,
        nameKana,
        bio,
        timeline: textToTimeline(timelineText),
        credentials: credentialsText.split('\n').map((s) => s.trim()).filter(Boolean),
      }, { merge: true });
      setStatus('保存しました。');
    } catch (err) {
      setStatus('保存に失敗しました。');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="admin-panel admin-form" onSubmit={onSave}>
      <label className="admin-form__field">
        <span>氏名</span>
        <input value={name} onChange={(e) => setName(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>ふりがな</span>
        <input value={nameKana} onChange={(e) => setNameKana(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>紹介文</span>
        <textarea rows={5} value={bio} onChange={(e) => setBio(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>経歴（1行ずつ「年代｜内容」の形式。例：令和2年｜「虹嶺庵」を開業）</span>
        <textarea rows={6} value={timelineText} onChange={(e) => setTimelineText(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>資格・認定（1行に1つ）</span>
        <textarea rows={5} value={credentialsText} onChange={(e) => setCredentialsText(e.target.value)} />
      </label>

      <button className="admin-form__submit" type="submit" disabled={saving}>
        {saving ? '保存中...' : '保存する'}
      </button>

      {status && <p className="admin-form__status">{status}</p>}
    </form>
  );
}
